import { render, staticRenderFns } from "./storagePolicy.vue?vue&type=template&id=ee5649a6&"
import script from "./storagePolicy.vue?vue&type=script&lang=js&"
export * from "./storagePolicy.vue?vue&type=script&lang=js&"
import style0 from "./storagePolicy.vue?vue&type=style&index=0&id=ee5649a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports